import React, { createContext, useState } from 'react';

// CRIADO PARA GERAR VARIÁVEIS GLOBAIS COM USESTATE

export const NavigateWayContext = createContext();

export const NavigateWayProvider = ({ children }) => {

  // guarda o caminho de navegação entre as páginas do fluxo site > room > rack > map 
  const [navigateWay, setNavigateWay] = useState({
    site: '/',
    room: '/',
    map: '/',
    newcount: '/',
    diagram: '/'
  });

  return (
    <NavigateWayContext.Provider value={{ navigateWay, setNavigateWay }}>
      {children}
    </NavigateWayContext.Provider>
  );
};